import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"
// -- import * as _ from "lodash-es"
import * as biz_data_helper from "../shared/biz_data_helper"
import cars from "./modules/cars"

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== "production"
// const _is_production = window.location.host.indexOf("cpspcloud") > -1;

export default new Vuex.Store({
  state: {
    biz_data: {
      userInfo: {
        last_plant_setting: {}
      },
      plantSetting: {},
      baseData: {},
      templateData: {},
      Relation: {},
      kvData: {},
      all_fields_list: []
    },
    is_production: debug,
    //col-setting
    selectOrderByItems: [],
    selectColHeader: [], //存放列名显示 items
    allhearder: [],
  },
  mutations: {
    init_biz_data(state, data_info) {
      biz_data_helper.init_biz_data(state, data_info)
    },
    add_biz_data(state, data_info) {
      biz_data_helper.add_biz_data(state, data_info)
    },
    remove_biz_data(state, data_info) {
      biz_data_helper.remove_biz_data(state, data_info)
    },
    update_biz_data(state, data_info) {
      biz_data_helper.update_biz_data(state, data_info)
    },
  },

  modules: {
    cars
  },
  plugins: [
    createPersistedState({
      key: "cpsp-store",
      storage: window.sessionStorage,
      paths: [
        // "biz_data.userInfo",
        // "biz_data.plantSetting",
        // "biz_data.baseData",
        // "biz_data.Relation",
        // "cars"
      ]
    })
  ],
  strict: debug
})
